import React, { useRef } from 'react'

import IdleTimer from 'react-idle-timer'
import { useDispatch } from 'react-redux'

import { Container, makeStyles } from '@material-ui/core'

import { signOut } from '../../store/actions'

import Aux from '../Auxiliary/Auxiliary'
import Header from '../../components/Header/Header'

const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {
    position: 'relative',
    top: 64,
    left: 57 / 2,
    width: 'calc(100% - 57px)',
    padding: spacing(1.5),
    backgroundColor: 'inherit'
  }
}))

const Layout = ({ children }) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const timeoutMinutes = process.env.REACT_APP_IDLE_TIMER || 10
  const timeoutMili = timeoutMinutes * 60 * 1000
  let idleTimer = useRef(null)

  const onAction = e => {
    if (idleTimer) {
      idleTimer.reset()
    }
  }

  const onIdle = e => {
    dispatch(signOut())
  }

  return (
    <Aux>
      <IdleTimer
        ref={ref => {
          idleTimer = ref
        }}
        element={document}
        onAction={onAction}
        onIdle={onIdle}
        debounce={250}
        timeout={timeoutMili}
      />
      <Header />
      <Container disableGutters classes={{ root: classes.root }}>
        {children}
      </Container>
    </Aux>
  )
}

export default Layout
